import * as React from "react";
import {
    Grid
} from "@material-ui/core";
import { inject, observer } from "mobx-react";
import LabelerSegmentationUiStore from "../../../../store/segmentation-store/labelerSegmentationUiStore";
import LabelerSegmentationStore from "../../../../store/segmentation-store/labelerSegmentationStore";

const ColorItem = ({index, tag, labelerSegmentationUiStore, labelerSegmentationStore}: any) => {

    const {
        tagSelectedIndex,
        setTagSelectedIndex,
        findPolygonNotDone,
        createPolygon,
        createLabelValue,
        updatePolygon,
        activePolygon,
        polygons
    } = labelerSegmentationUiStore as LabelerSegmentationUiStore

    const {
        deleteSegmentByName
    } = labelerSegmentationStore as LabelerSegmentationStore

    const selected = index === tagSelectedIndex

    const handleClick = () => {
        const polyNotDone = findPolygonNotDone();
        if (polyNotDone) {
            deleteSegmentByName(polyNotDone.labelValue);
            setTagSelectedIndex(index);
            createPolygon(polyNotDone.points);
            return;
        }

        if (activePolygon) {
            // update polygone classe
            const polygon = polygons.find(p => p.labelValue === activePolygon.name)
            if (polygon) {
                setTagSelectedIndex(index);
                
                const newlabelValue = createLabelValue();
                updatePolygon(polygon, { labelValue: newlabelValue });

                deleteSegmentByName(polygon.labelValue);
            }
            return;
        }

        setTagSelectedIndex(index);
    }

    return (
        <Grid
            item
            style={{
                display: "flex",
                width: "25px",
                height: "25px",
                borderRadius: "15%",
                backgroundColor: tag.color,
                // border: selected ? "2px solid black": "none",
                boxShadow: selected ? tag.color + " 0px 0px 4px" : "none",
                cursor: "pointer"
            }}
            onClick={handleClick}
        />
    )
}

export default inject("labelerSegmentationUiStore", "labelerSegmentationStore")(observer(ColorItem))